import Modal from "../Modal/Modal";
import ShareUserPicker from "./ShareUserPicker";

export default function ShareModal({
  open,
  onClose,
  item,
  itemTypeLabel = "template",
  shareEndpoint,
  buildPayload,
  title,
  description,
  excludeUserId,
  parseShareResponse,
  alreadyHasAccessMessage,
  filterByCustomer,
}) {
  return (
    <Modal
      title={title || `Share "${item?.name ?? ""}"`}
      open={open}
      handleClose={onClose}
      showActions={false}
      width="650"
    >
      <ShareUserPicker
        item={item}
        itemTypeLabel={itemTypeLabel}
        shareEndpoint={shareEndpoint}
        buildPayload={buildPayload}
        onClose={onClose}
        description={description}
        excludeUserId={excludeUserId}
        parseShareResponse={parseShareResponse}
        alreadyHasAccessMessage={alreadyHasAccessMessage}
        filterByCustomer={filterByCustomer}
      />
    </Modal>
  );
}
